import { pageTitle } from '@/utils/page-metadata';
import React, { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const MobilePageContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { pathname } = useLocation();
    const contentRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        document.title = pageTitle(pathname);
        if (contentRef.current) {
            contentRef.current.scrollTop = 0;
            contentRef.current.scrollLeft = 0;
        }
    }, [pathname]);

    return (
        <div
            ref={contentRef}
            role='region'
            aria-label='Page content'
            className='min-h-0 min-w-0 flex-1 overflow-y-auto overscroll-y-contain bg-vscode-bg pb-[env(safe-area-inset-bottom)]'
        >
            {children}
        </div>
    );
};
